<template>
  <div class="redirect-page">
    <p>正在处理授权登录...</p>
  </div>
</template>

<script>
import axios from 'axios'
import { setToken, setUser } from '@/utils/auth'
import { EventBus } from '@/utils/event-bus'

export default {
  name: 'OpenAuthRedirectTarget',
  mounted() {
    this.handleAuth()
  },
  methods: {
    handleAuth() {
      const authtype = localStorage.getItem('authtype')
      const query = this.$route.query
      let url = ''
      if (authtype === 'wxlogin') {
        url = '/realNet/vxlogin/getInfo'
      } else if (authtype === 'weibologin') {
        url = '/realNet/wblogin/getInfo'
      } else if (authtype === 'alilogin') {
        url = '/realNet/alilogin/getInfo'
      }
      if (!url) {
        this.$router.push('/')
        return
      }
      axios({ url, method: 'get', params: query }).then(res => {
        if (res.data.code === 200) {
          const result = res.data.result
          if (result.token) {
            setToken(result.token)
            setUser(JSON.stringify(result.user))
            this.$store.state.name = result.user.name
            this.$store.state.avatar = result.user.avatar
            EventBus.$emit('getUser', result.user)
            this.$store.commit('setLoginStatus', true)
            this.$router.push('/')
          } else if (result.data) {
            this.$store.state.data = result.data
            this.$store.state.nickname = result.nickname || ''
            this.$router.push('/')
          }
        } else {
          this.$message({ message: res.data.message || '授权失败', type: 'error' })
          this.$router.push('/')
        }
      }).catch(() => {
        this.$router.push('/')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.redirect-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  p { font-size: 16px; color: #999; }
}
</style>
